// Centraliza a URL base da API
// Sempre usa /api (proxy pelo nginx em produção, ou configurar proxy local)
export const API_BASE = '/api';

// Helper para construir URLs
export const apiUrl = (path = '') => `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
